<template>
  <div>
    <div class="hint-box">
      <p class="hint">
        <i class="el-icon-s-opportunity"></i> 温馨提示：由于B2B交易的特殊性，产品若无质量问题，概不退换
      </p>
    </div>
    <div class="order-create">
      <el-steps :active="1" finish-status="success" align-center>
        <el-step title="我的购物车"></el-step>
        <el-step title="填写核对订单"></el-step>
        <el-step title="提交订单"></el-step>
        <el-step title="确认订单"></el-step>
        <el-step title="生成订单"></el-step>
      </el-steps>
     <el-divider></el-divider>
      <div class="address-box">
        <p style="display:flex;justify-content: space-between">
          <span>收货人信息</span>
          <el-button class="common-btn" @click="choseAddressModal = true">选择收货地址</el-button>
        </p>
      </div>
      <p style="margin-top: 12px;">
        <el-radio-group v-model="address">
          <el-radio
            :label="choseAddress.id"
          >{{choseAddress.receiverProvince}}{{choseAddress.receiverCity}}{{choseAddress.receiverDistrict}}{{choseAddress.receiverAddress}}
          ({{choseAddress.receiverName}}：{{choseAddress.receiverPhone}})</el-radio>
        </el-radio-group>  
     </p>  
      <el-divider></el-divider>
      <div class="pay-hint">
        <i class="el-icon-warning-outline">订单中所有商品均需要商家确认货期后，再完成支付</i>
        <div style="display:flex;justify-content: space-between; float:right;">
          <!-- <span>送货清单</span> -->
          <div>
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              content="因可能存在系统缓存、页面更新导致价格变动异常等不确定性情况出现,商品售价以本结算页商品价格为准"
            >
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
            <span style="margin-right: 10px;">价格说明</span>
            <el-button type="text" class="common-btn-text common-btn-text-c1" @click="$router.push('/cart')">修改购物车</el-button>
          </div>
        </div>
      </div>

      <el-divider></el-divider>
      <!-- <div class="pay-way">
        <p>支付方式</p>
        <el-radio-group style="margin-top: 12px;" v-model="payway" size="small">
          <el-radio-button label="线下支付"></el-radio-button>
          <el-radio-button label="授信支付" v-if="$store.state.user.info.beforehandLimit > totalMoney"></el-radio-button>
        </el-radio-group>
      </div>-->
      <!-- <el-divider></el-divider> -->

      <div class="goods-list">
        <!-- :show-header="false" -->
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;margin: 20px 0"
          :cell-class-name="delLine"
        >
          <el-table-column align="right" prop="name" label width="100">
            <template slot-scope="scope">
              <img
                :src=" scope.row.commodity && scope.row.commodity.defaultImage"
                style="max-width: 100px;max-height: 60px;"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" prop="commodity.name" label="商品">
            <template slot-scope="scope">
                {{scope.row.commodity.name}}
                <label v-if="scope.row.commodity.status == 0" style="color:red">
                    (已下架)
                </label>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="commodity.marketPrice" label="市场价(元)" width="160"></el-table-column>
          <!-- <el-table-column
            align="center"
            prop="commodity.collectivePrice"
            label="采集价(元)"
            width="160"
          ></el-table-column> -->
          <el-table-column align="center" prop="quantity" label="数量" width="100"></el-table-column>
          <el-table-column align="center" label="小计（元）" width="160">
            <template slot-scope="scope">
              <p>{{scope.row.commodity && (scope.row.commodity.price*scope.row.quantity).toFixed(2)}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200" v-if="deleteCommodity.length > 0">
            <template slot-scope="scope" v-if="scope.row.commodity.status === 0">
              <button class="common-btn" @click="choseGoods(scope.row)">替换</button>
              <el-popconfirm title="确认删除该商品，可以选择替换？" @confirm="deleteGoods(scope.row)">
                <button class="common-btn" slot="reference">删除</button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div>
        <p>配送方式</p>
        <el-radio-group style="margin-top: 12px;" v-model="distribution" size="small">
          <el-radio-button label="普通快递"></el-radio-button>
          <el-radio-button label="特殊物流"></el-radio-button>
        </el-radio-group>
      </div>-->
      <!-- <div class="info-box">
        <p>发票信息</p>
        <p>使用优惠/礼品卡/抵用</p>
      </div>-->
      <div class="price-info">
        <p>
          <span>{{tableData.length}}件商品，总金额：</span>
          <span>￥{{totalMoney}}</span>
        </p>
        <!-- <p>
          <span>运费：</span>
          <span>￥{{freight}}</span>
        </p>-->
        <!-- <p>
          <span>返现：</span>
          <span>-￥{{0.00}}</span>
        </p> -->
        <p>
          <span>商品优惠：</span>
          <span>-￥{{preferentialMoney}}</span>
        </p>
      </div>
      <div class="total">
        <p>
          <span>应付总额：</span>
          <span>￥{{(Number(totalMoney) + freight).toFixed(2)}}</span>
        </p>
        <p>寄送至：{{choseAddress.receiverProvince}}{{choseAddress.receiverCity}}{{choseAddress.receiverDistrict}}{{choseAddress.receiverAddress}}
          ({{choseAddress.receiverName}}：{{choseAddress.receiverPhone}})
        </p>
      </div>
      <div style="text-align: right;">
        <button class="common-btn-primary" v-if="userType == 1" @click="userModalChange">代客户下单</button>
        <button class="common-btn" @click="createOrder">提交订单</button>
        <button class="common-btn cancel" @click="goBack">返回</button>
      </div>
    </div>

    <el-dialog class="address-modal" title="收货地址" :visible.sync="addressModal" width="600px">
      <el-form :model="addressData">
        <el-form-item label="省/市/区" :label-width="labelWidth">
          <el-cascader v-model="addressData.address" :options="area" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="labelWidth">
          <el-input v-model="addressData.receiverAddress"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="labelWidth">
          <el-input v-model="addressData.receiverName"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="labelWidth">
          <el-input maxlength="11" v-model="addressData.receiverPhone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addressModal = false">取 消</el-button>
        <el-button type="primary" @click="addAddress">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="address-modal" title="选择收货地址" :visible.sync="choseAddressModal" width="700px">
      <el-table
        ref="multipleTable"
        :data="addressList"
        tooltip-effect="dark"
        style="width: 100%;margin-left: 12px"
        @selection-change="handleSelectionAddressChange"
      >
        <el-table-column align="center" type="selection" width="50"></el-table-column>
        <el-table-column align="center" prop="receiverName" label="收货人" width="120"></el-table-column>
        <el-table-column align="center" prop="receiverPhone" label="联系电话" width="150"></el-table-column>
        <el-table-column align="center" prop="address_" label="收货地址" width="350">
          <template slot-scope="scope">
            <span>{{scope.row.receiverProvince}}{{scope.row.receiverCity}}{{scope.row.receiverDistrict}}{{scope.row.receiverAddress}}</span> 
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="choseAddressModal = false">取 消</el-button>
        <el-button type="primary" @click="choseUserAddress">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="address-modal" title="客户列表" :visible.sync="userModal" width="800px">
      <el-table
        ref="multipleTable"
        :data="userData"
        tooltip-effect="dark"
        style="width: 100%;margin-left: 12px"
        @selection-change="handleSelectionUserChange"
      >
        <el-table-column align="center" type="selection" width="50" :selectable='userCheck' :reserve-selection="true"></el-table-column>
        <el-table-column align="center" prop="name" label="用户名" width="120"></el-table-column>
        <el-table-column align="center" prop="company" label="所属公司" width="150"></el-table-column>
        <el-table-column align="center" prop="telphone" label="联系电话" width="150"></el-table-column>
        <el-table-column align="center" prop="address_" label="收货地址" width="320">
          <template slot-scope="scope">
            <el-button v-if="scope.row.address == null"
             class="common-btn-primary"
             size="mini"
             @click="addUserAddress(scope.row.id)">添加地址</el-button>
            <span v-else>{{scope.row.address}}</span> 
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userModal = false">取 消</el-button>
        <el-button type="primary" @click="createUserOrder">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="替换商品" :visible.sync="switchModal">
      <el-input class="input" v-model="query.keyword" @keyup.enter.native="searchGoods">
        <i slot="suffix" class="el-input__icon el-icon-search" @click="searchGoods"></i>
      </el-input>
      <el-table
        ref="multipleTable"
        :data="switchData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="right" prop="name" label width="100">
          <template slot-scope="scope">
            <router-link
              :to="{path:`/goodsdetail?id=${scope.row.id}&groupNo=${scope.row.groupNo||''}`}"
            >
              <img
                :src="scope.row.defaultImage"
                style="max-width: 100px;max-height: 60px;cursor: pointer;"
              />
            </router-link>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="name" label="商品">
          <template slot-scope="scope">
            <router-link
              :to="{path:`/goodsdetail?id=${scope.row.id}&groupNo=${scope.row.groupNo||''}`}"
            >{{scope.row.name}}</router-link>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="price" label="单价（元）" width="200"></el-table-column>
        <el-table-column align="center" prop="quantity" label="数量" width="200">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.quantity"
              :min="1"
              size="small"
              style="width: 120px"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right;margin-top: 12px"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page.sync="query.pageNo"
        :page-sizes="[4, 6, 8, 10]"
        :page-size="query.pageSize"
        layout="sizes, prev, pager, next"
        :total="query.total"
      ></el-pagination>
      <div class="foot">
        <button class="common-btn-primary" @click="confirmSwitch">确认</button>
        <button class="common-btn" @click="switchModal = false">取消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import area from "../../js/china.json";
import {
  cartList,
  findSysCommodityOrderByOrderId,
  addressAdd,
  addressList,
  addOrder,
  commodityGroup,
  goodsList,
  getUsersBySalesman,
  buyAgain
} from "@/js/api";
export default {
  name: "createOrder",
  computed: {
    totalMoney() {
      let marketTotal = 0;
      let total = 0;
      this.tableData.map(z => {
        total += (z.commodity && z.commodity.price * z.quantity) || 0;
        marketTotal += (z.commodity && z.commodity.marketPrice * z.quantity) || 0;
      });
      return total.toFixed(2);
    },
    preferentialMoney() {
      let marketTotal = 0;
      let total = 0;
      this.tableData.map(z => {
        total += (z.commodity && z.commodity.price * z.quantity) || 0;
        marketTotal += (z.commodity && z.commodity.marketPrice * z.quantity) || 0;
      });
      return (marketTotal - total).toFixed(2);
    }
  },
  data() {
    return {
      userType: this.$store.state.user.info.userType,
      area,
      labelWidth: "120px",
      addressModal: false,
      userId: 0,
      choseAddressModal: false,
      userModal: false,
      choseAddress: {},
      addressData: {
        address: [],
        receiverProvince: "",
        receiverCity: "",
        receiverDistrict: ""
      },
      address: 0,
      addressList: [],
      payway: "线下支付",
      freight: 0,
      distribution: "",
      tableData: [],
      query: {
        pageNo: 1,
        pageSize: 6,
        total: 0,
        keyword: ""
      },
      deleteCommodity: [],
      switchModal: false,
      switchData: [],
      switchGood: {},
      tihuanCommodity: {commodity:{},quantity:1},
      multipleSelection: [],
      multipleUserSelection: [],
      multipleAddressSelection: [],
      userData: []
    };
  },
  watch: {
    $route: function() {
      commodityGroup({
        id: this.$route.query.id,
        groupNo: ""
      }).then(res => {
        if (res.code == 0) {
          const list = res.result || [];
          list.map(z => {
            z.commodity = z;
            z.quantity = this.$route.query.number || 1;
            z.commodity.price =
              z.commodity.collectivePrice || z.commodity.marketPrice;
          });
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  mounted() {
    this.getAddress();
    if (this.userType === 1) {
      userModalChange();
    }
    // 直接购买商品
    if (this.$route.query.id) {
      commodityGroup({
        id: this.$route.query.id,
        groupNo: ""
      }).then(res => {
        if (res.code == 0) {
          const list = res.result || [];
          list.map(z => {
            z.commodity = z;
            z.quantity = this.$route.query.number || 1;
            z.commodity.price =
              z.commodity.collectivePrice || z.commodity.marketPrice;
          });
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    } else if (this.$route.query.ids) {
      const ids = JSON.parse(this.$route.query.ids);
      // 从购物车下单
      cartList({
        userId: this.$store.state.user.info.id
      }).then(res => {
        if (res.code == 0) {
          const list = res.result.records || [];
          list.map(z => {
            if (z.commodity) {
              z.commodity.price =
                z.commodity.collectivePrice || z.commodity.marketPrice;
            }
          });
          this.tableData = list.filter(z => ids.includes(z.id));
        } else {
          this.$message.error(res.message);
        }
      });
    } else if (this.$route.query.orderId) {
      // 再次购买
      buyAgain({
        orderId: this.$route.query.orderId
      }).then(res => {
        if (res.code == 200) {
          const list = res.result || [];
          list.map(z => {
            if (z.commodity) {
              z.commodity.price =
                z.commodity.collectivePrice || z.commodity.marketPrice;
                console.info(z.commodity.status)
                console.info(z.commodity.status == 0)
              if(z.commodity.status == 0){
                  this.deleteCommodity.push(z.commodity.id)
              }  
            }
          });
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  methods: {
    // 替换商品
    choseGoods(item) {
      this.switchData = [];
      this.switchModal = true;
      this.switchGood = item;
      this.searchGoods();
    },
    // 删除商品
    deleteGoods(item) {
      this.switchData = [];
      this.switchGood = item;
      for(let i=0; i<this.tableData.length; i++){
        if(this.tableData[i].commodity.status == 0 && this.tableData[i].commodity.id == this.switchGood.commodity.id){
          this.tableData.splice(i,1);
        }
      }
    },
    userModalChange() {
      getUsersBySalesman({}).then(res => {
        if (res.code == 0) {
          const list = res.result || [];
          if (res.result.length > 0) {
            this.userData = list;
            this.userModal = true;
          }else{
            this.$message.warning("当前账号下未关联客户！");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    pageChange: function(page) {
      this.query.pageNo = page;
      this.searchGoods();
    },
    pageSizeChange: function(size) {
      this.query.pageSize = size;
      this.searchGoods();
    },
    searchGoods() {
      // 普通查询
      const sdata = {
        name: this.query.keyword || "",
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      };
      // 其他查询商品
      goodsList(sdata).then(res => {
        if (res.code == 0) {
          this.query.total = res.result.total;
          const switchData = res.result.records || [];
          switchData.map(z => {
            z.commodity = z;
            z.quantity = 1;
            z.commodity.price =
              z.commodity.collectivePrice || z.commodity.marketPrice;
          });
          this.switchData = switchData;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionUserChange(val) {
      this.multipleUserSelection = val;
    },
    handleSelectionAddressChange(val) {
      this.multipleAddressSelection = val;
    },
    userCheck(row,index){
      if(row.address == null || row.address == ''){
         return false;
      }else{
        return true;
      }
    },
    // 删除线
    delLine ({ row, column, rowIndex, columnIndex }) {
       if(row.commodity && row.commodity.hasOwnProperty('status') && row.commodity.status == 0) return 'del_line'
    },
    // 替换商品
    confirmSwitch() {
      if(this.multipleSelection.length == 0){
        this.$message.error("请选择替换的商品！");
        return
      }

      // 先删除需要替换下架商品
      for(let i=0; i<this.tableData.length; i++){
        if(this.tableData[i].commodity.status == 0 && this.tableData[i].commodity.id == this.switchGood.commodity.id){
          this.tableData.splice(i,1);
        }
      }
      //叠加相同的元素
      for(let j=0; j<this.multipleSelection.length; j++){
        this.tihuanCommodity = {commodity:{},quantity:1}
        let isAdd = true
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].commodity.id == this.multipleSelection[j].id) {
            this.tableData[i].quantity += z.quantity;
            this.multipleSelection.splice(j,1)
            isAdd = false
            break
          }
        }
        if(isAdd){
          this.tihuanCommodity.commodity = this.multipleSelection[j]
          this.tihuanCommodity.quantity = this.multipleSelection[j].commodity.quantity
          this.tableData.push(this.tihuanCommodity);
        }
      }

      this.switchModal = false;
    },
    // 代客户下单
    createUserOrder() {
      this.userModal = false;
      this.createOrder();
    },
    addUserAddress(userId){
      this.addressModal = true;
      this.userId = userId;
    },
    addLocalAddress(){
      this.addressModal = true;
      this.userId = 0;
    },
    choseUserAddress(){
      if(this.multipleAddressSelection.length > 1){
        this.$message.warning("收货地址只能选择一个！");
        return;
      }
      if(this.multipleAddressSelection.length == 1){
        const choseId = this.multipleAddressSelection[0].id;
        this.addressList.map(z => {
            if(z.id == choseId){
               this.choseAddress = z;
               this.address = z.id;
            }
        });
      }
      this.choseAddressModal = false;
    },
    getAddress() {
      addressList({
        userId: this.$store.state.user.info.id,
        pageSize: 10
      }).then(res => {
        if (res.code == 200) {
          const list = (res.result && res.result.records) || [];
          list.map(z => {
             if(z.isDefault == 0){
               this.choseAddress = z;
               this.address = z.id;
             }
          });
          this.addressList = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleChange(e) {
      this.addressData.receiverProvince = e[0];
      this.addressData.receiverCity = e[1];
      this.addressData.receiverDistrict = e[2];
    },
    addAddress: function() {
      if(this.userId != 0){
        this.addressData.userId = this.userId;
      }
      addressAdd(this.addressData).then(res => {
        if (res.code == 200) {
          this.addressModal = false;
          this.$message.success(res.message);
          if(this.userId == 0){
            this.getAddress();
          }else{
            this.userModalChange();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    createOrder: function() {
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      const address = this.choseAddress;
      if (this.multipleUserSelection.length === 0) {
        if (!address) return this.$message.warning("请选择收货地址！");
      }
      if (this.deleteCommodity.length > 0) {
        return this.$message.warning("请删除或是替换已下架的商品！");
      }
      const sdata = this.tableData.map(z => ({
        commodityId: z.commodity.id,
        itemNumber: z.commodity.atrNo,
        groupNo: z.commodity.groupNo,
        commodityName: z.commodity.name,
        discountPrice: z.commodity.price,
        unit: z.quantity,
        unitPrice: z.commodity.price,
        cargoDate: z.commodity.deliveryTime, //货期
        consigneePhone: !address ? "" : address.receiverPhone,
        consignee: !address ? "" : address.receiverName,
        receivingAddress: !address
          ? ""
          : `${address.receiverProvince} ${address.receiverCity} ${address.receiverAddress}`,
        freight: this.freight,
        itemNumber: z.commodity.atrNo,
        pictureUrl: z.commodity.defaultImage,
        userIds: this.multipleUserSelection.map(z => z.id).join(","),
        name: ''
      }));

      this.$prompt("请输入订单名称", "订单名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "订单名称不能为空"
      }).then(({ value }) => {
          sdata.map(z => {
            z.name = value
          })
          addOrder(sdata).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message);
              if (this.multipleUserSelection.length == 0) {
                this.$router.push("/order/orderDetail?id=" + res.result);
              } else {
                this.$router.push("/cart");
              }
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消"
          });
        });
    },
    goBack(){
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="less">
.del_line {
    text-decoration:line-through;
}
</style>
<style lang="less" scoped>
.hint-box {
  background: #000;
  color: #fff;
  .hint {
    margin: auto;
    width: 1060px;
    line-height: 24px;
  }
}
.order-create {
  margin: 20px auto;
  width: 1060px;
  .title {
    margin: 20px 0;
  }
  .pay-hint {
    i {
      color: #333;
      &::before{margin-right: 10px;}
    }
  }
  .info-box {
    margin-top: 20px;
    p {
      line-height: 24px;
    }
  }
  .price-info {
    padding: 10px 20px;
    text-align: right;
    line-height: 24px;
    p span:last-child {
      display: inline-block;
      width: 120px;
    }
  }
  .total {
    margin-bottom: 12px;
    padding: 12px 20px;
    text-align: right;
    line-height: 2;
    border: solid 1px #ffa626;
    p span:last-child {
      display: inline-block;
      width: 120px;
      font-size: 20px;
    }
  }
}
.address-modal {
  .el-input,
  .el-cascader {
    width: 400px;
  }
}
.foot {
  margin-top: 20px;
  text-align: right;
}


</style>

